export default class MessageForm {
  public content: string = ''
  public targetableId: number
  public targetableType: string = ''
  public threadId: string = ''
  public attachmentIds: number[] = []
  public metadata: any = {}
  public aiChatQuestionId: number = null
}
